export default __webpack_public_path__ + "static/media/NEXTICONA.84d058da.svg";